import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 5a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2l0 -14","key":"svg-0"}],["path",{"d":"M11 4h2","key":"svg-1"}],["path",{"d":"M12 9.5l-1 2.5h2l-1 2.5","key":"svg-2"}]]

const IconDeviceMobileCharging = createReactComponent('outline', 'device-mobile-charging', 'DeviceMobileCharging', __iconNode);

export default IconDeviceMobileCharging;